import React, { useEffect, useState, useContext, useRef } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { v4 as uuidv4 } from "uuid";
import { setPrices, setPricesVatInc, tooltips } from "../popData";
// import "../firebase";
import { RatesContext } from "../providers/RatesProvider";
import { OperativesContext } from "../providers/OperativesProvider";

import Footer from "./Footer";
import { useJobDescription } from "../customHooks/useJobDescription";

import CloseIcon from "@mui/icons-material/Close";

import {
  calcCardFee,
  calcJobsTotalCost,
  calcLabourDifference,
  calcPreVatAmount,
  calcRateAmount,
  calcVat,
  calcVatInclusive,
} from "../helperFunctions/calculationFunctions";
import { getDbRef } from "../helperFunctions/determineType";
import "../css/jobDescription.scss";
import { MaterialsCosts, LabourCosts } from "./CostCards";
import IdentifierBar from "./IdentifierBar";
import { useJobDescriptions } from "../customHooks/useJobDescriptions";
import { deleteField, doc, updateDoc } from "firebase/firestore";
import { SlidersContext } from "../providers/SlidersProvider";
import JobDescriptionTemplates from "./JobDescriptionTemplates";
import { SettingsContext } from "../providers/SettingsProvider";
import FooterBtn from "./FooterBtn";

const JobDescription = () => {
  const location = useLocation();
  const history = useHistory();
  const params = useParams();

  const { sliders, setSliderId } = useContext(SlidersContext);
  const { vat } = useContext(SettingsContext);
  const showVat = location?.state?.primaryData?.vatMode;

  const [targetPrice, setTargetPrice] = useState(0);
  const [targetPriceError, setTargetPriceError] = useState("0");

  // const setPriceData = vat ? setPricesVatInc : setPrices;
  const setPriceData = setPrices;
  const [setPrice, setSetPrice] = useState(setPriceData[0]);
  const [customSetPrice, setCustomPrice] = useState({
    name: "",
    quantity: 0,
    price: 0.0,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let dbRef = getDbRef(location.state.type);

  const inputRef = useRef(null);
  const jobDescriptions = useJobDescriptions(location.state.timesheetId, dbRef);
  const jobDescription = useJobDescription(dbRef);
  const rates = useContext(RatesContext);
  const operatives = useContext(OperativesContext);

  const [details, setDetails] = useState(jobDescription?.details ?? "");

  const setPriceList = jobDescription?.setPriceList ?? [];

  useEffect(() => {
    setDetails(jobDescription?.details ?? "");
  }, [jobDescription?.details]);

  const [jobDocRef] = useState(doc(dbRef, location.state.timesheetId, "jobDescriptions", params.uid));

  const inputHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    updateDoc(jobDocRef, { [name]: value });
  };

  const handleDetails = (e) => {
    let value = e.target.value;

    setDetails(value);
  };

  const editMaterials = function () {
    history.push(`/${location.state.type}/materials`, {
      materials: jobDescription.materials,
      jobDescId: params.uid,
      timesheetId: location.state.timesheetId,
      type: location.state.type,
    });
  };

  const handleRate = (e) => {
    let ratePerHour = 0;
    let rateAccessId = 0;

    let value = e.target.value;
    let selectedRate = rates.find((r) => r.uid === value);

    if (selectedRate) {
      ratePerHour = selectedRate.ratePerHour;
      rateAccessId = selectedRate.accessId;
    }

    // if (vat) {
    //   // ratePerHour = calcRateAmount(ratePerHour, 0, vat)[0];
    //   ratePerHour = calcPreVatAmount(ratePerHour);
    // }

    updateDoc(jobDocRef, { ratePerHour, rateUid: value, rateAccessId });
  };

  const handleOperatives = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let checked = e.target.checked;

    let mapOperation = checked ? value : deleteField();
    updateDoc(jobDocRef, {
      [`operatives.${name}`]: mapOperation,
    }).then(() => {
      // Can handle success or failure of updating operatives
    });
  };

  let totalJobsCost = calcJobsTotalCost(jobDescriptions, vat)[4];
  const [vatCost, inc] = calcVat(totalJobsCost, showVat);

  // SetPrice Functions ///////////////////////////////////////////////////

  function removeSetPrice(uid) {
    let filteredList = setPriceList.filter((item) => item.uid !== uid);

    updateDbSetPriceList(filteredList);
  }

  function settlePrice(e) {
    let foundPrice = setPriceData.find((p) => p.uid === e.target.value);
    setSetPrice({ ...foundPrice });
  }

  const updateDbSetPriceList = (newSetPriceList) => {
    updateDoc(jobDocRef, {
      setPriceList: [...newSetPriceList],
    }).then(() => {});
  };

  const updateSetPriceList = () => {
    //Current item is setPrice

    //Loop through setPriceList to see if it already contains setPrice
    let newSetPriceList = [...setPriceList];

    let isPresent = newSetPriceList.find((item) => {
      return setPrice.uid === item.uid;
    });

    if (isPresent) {
      newSetPriceList = newSetPriceList.map((item) => {
        if (item.uid === isPresent.uid) {
          return { ...item, quantity: item.quantity + 1 };
        } else {
          return item;
        }
      });
    } else {
      newSetPriceList.push({ ...setPrice, quantity: 1 });
    }

    updateDbSetPriceList(newSetPriceList);
  };

  function updateCustomPrices() {
    let setPriceUid = uuidv4();
    let newSetPriceList = [...setPriceList];

    newSetPriceList.push({ ...customSetPrice, uid: setPriceUid });

    updateDbSetPriceList(newSetPriceList);
  }

  function changeCustomSetPrice(e) {
    let name = e.target.name;
    let value = e.target.value;

    let currentCustomSetPrice = { ...customSetPrice };

    currentCustomSetPrice[name] = value;
    setCustomPrice(currentCustomSetPrice);
  }

  function changeTargetPrice(e) {
    // Update targetPrice
    setTargetPrice(e.target.value);
  }

  function addLabourDifference() {
    setTargetPriceError("");

    const target = Number(targetPrice) || 0;

    if (isNaN(target)) {
      // set error
      setTargetPriceError("Enter valid number");
      return;
    }

    // Calculate the difference between target price and current total
    const labourDifferenceTotal = calcLabourDifference(target, inc, showVat);

    // Add a new custom set price: name: labour | value: difference
    let setPriceUid = uuidv4();
    let newSetPriceList = [...setPriceList];

    let labourDifferencePrice = {
      name: "Labour",
      quantity: 1,
      price: labourDifferenceTotal,
    };

    newSetPriceList.push({ ...labourDifferencePrice, uid: setPriceUid });

    updateDbSetPriceList(newSetPriceList);
  }

  function addCardFee(cardFeePercentage) {
    // let cardFee = -(Number(totalJobsCost) * cardFeePercentage).toFixed(2);
    let cardFee = -calcCardFee(inc, cardFeePercentage, vat);

    let setPriceUid = uuidv4();
    let newSetPriceList = [...setPriceList];

    let cardFeeSetPrice = {
      name: "Card Fee",
      quantity: 1,
      price: cardFee,
    };

    newSetPriceList.push({ ...cardFeeSetPrice, uid: setPriceUid });

    updateDbSetPriceList(newSetPriceList);
  }

  // End of SetPrice Functions ///////////////////////////////////////////////

  return (
    <div className="jobDescriptionPage">
      <Footer title={"Job Description"} back={true}>
        {sliders && (
          <>
            <button
              title={tooltips.closeSlider}
              className="adder slider-control"
              onClick={() => setSliderId(null)}
            >
              <CloseIcon style={{ fontSize: 28 }} />
            </button>
            <hr />
          </>
        )}

        {vat && (
          <FooterBtn title={tooltips.vatMode} cb={null}>
            <span className="vat-button" style={{ color: `${showVat ? "#24a218" : "#5d5d5d"}` }}>
              vat
            </span>
          </FooterBtn>
        )}
        <p className="adder">{inc}</p>

        <button title={tooltips.editMaterials} onClick={editMaterials} className="adder">
          <EditIcon style={{ fontSize: 28 }} />
        </button>
      </Footer>

      <IdentifierBar title="Job Description" back={true} />

      <div className="jdForm">
        <div className="section">
          <div className="formLine">
            <label htmlFor="jobDate">Date</label>
            <input
              id="jobDate"
              name="jobDate"
              type="date"
              value={jobDescription?.jobDate ?? ""}
              onChange={inputHandler}
            />
          </div>

          <div className="jdTemplatesBox">
            <div className="formLine">
              <label htmlFor="details">Details</label>
              <textarea
                ref={inputRef}
                rows={4}
                onBlur={inputHandler}
                onFocus={inputHandler}
                onChange={handleDetails}
                value={details}
                type="text"
                id="details"
                name="details"
              />
            </div>

            <JobDescriptionTemplates
              inputRef={inputRef}
              handleFormDetails={inputHandler}
              primaryData={location.state?.primaryData}
            />
          </div>
        </div>

        <div className="section">
          <h3 className="heading">Labour</h3>

          <div className="jobLabourLine">
            <div className="rateAndHours">
              <div className="formLine">
                <label htmlFor="hours">Hours</label>
                <input
                  onChange={inputHandler}
                  type="number"
                  id="hours"
                  name="hours"
                  value={jobDescription?.hours ?? 0}
                />
              </div>

              <div className="formLine">
                <label htmlFor="ratePerHour">Rate </label>
                <select
                  value={jobDescription?.rateUid ?? 0}
                  onChange={handleRate}
                  name="ratePerHour"
                  id="ratePerHour"
                >
                  <option key={0} value={0}>
                    Rate
                  </option>
                  {rates.map(({ name, uid, ratePerHour }) => {
                    return (
                      <option key={uid} value={uid}>
                        {name} - £{Number(ratePerHour).toFixed(2)}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="rateAmountBox">
              {/* <div> */}
              <div>
                <p>
                  <span className="equals">=</span> £{" "}
                  {calcRateAmount(jobDescription?.ratePerHour, jobDescription?.hours || 0, vat)[1]}
                </p>
                {/* {vat && <p>Hello</p>} */}
              </div>
              {/* </div> */}
            </div>
            {/* <div className="operativesLine">
              {operatives.map((op) => {
                let isChecked = jobDescription?.operatives?.hasOwnProperty(op.uid) ? true : false;
                return (
                  <div key={op.uid} className="formLine">
                    <label>{op.initials}</label>
                    <input
                      onChange={handleOperatives}
                      type="checkbox"
                      checked={isChecked}
                      value={op.rate}
                      name={op.uid}
                    />
                  </div>
                );
              })}
            </div> */}
          </div>

          {/* Set Prices */}
          <div className="setPricesSection">
            <div className="formLine setPricesLine">
              <label>Set Prices</label>
              <div className="setPricesControls">
                <div className="set-prices-dropdown-box">
                  <select onChange={settlePrice} value={setPrice.uid}>
                    {setPriceData.map(({ uid, name, price, display }) => {
                      // console.log("Set prices", name)
                      return (
                        <option value={uid} key={uid}>
                          {name} - £{Number(price).toFixed(2)}
                          {/* {name} - £{display} */}
                        </option>
                      );
                    })}
                  </select>
                  <button onClick={updateSetPriceList}>Add</button>
                </div>
                <div className="custom-set-prices-box">
                  <input
                    value={customSetPrice.desc}
                    onChange={changeCustomSetPrice}
                    placeholder="custom"
                    type="text"
                    name="name"
                  />
                  <div className="price-input">
                    <span>£</span>
                    <input
                      value={customSetPrice.price}
                      onChange={changeCustomSetPrice}
                      className="price arrowLess"
                      placeholder="0.00"
                      type="number"
                      name="price"
                    />
                  </div>
                  <input
                    value={customSetPrice.quantity}
                    onChange={changeCustomSetPrice}
                    className="quantity"
                    placeholder="0"
                    type="number"
                    name="quantity"
                  />
                  <button onClick={updateCustomPrices}>Add</button>
                </div>

                <hr />
                <br />

                <div className="cardFeeAndTargetPriceControls">
                  <button className="cardFeeBtn" onClick={() => addCardFee(0.0169)}>
                    <span className="cardFeeProvider">SumUp</span>
                    <span className="cardFeeLabel">£{calcCardFee(inc, 0.0169, false)}</span>
                    <span className="cardFeePercentage">(1.69%)</span>
                  </button>
                  {/* <button className="cardFeeBtn" onClick={() => addCardFee(0.0175)}>
                    <span className="cardFeeProvider">iZettle</span>
                    <span className="cardFeeLabel">£{calcCardFee(inc, 0.0175)}</span>
                    <span className="cardFeePercentage">(1.75%)</span>
                  </button> */}
                  <hr />
                  <div className="targetPriceControls">
                    {/* <span>{targetPrice}</span> */}

                    <div className="price-input">
                      <p className="price-makeup">Labour Calculator</p>
                      <span>£</span>
                      <input
                        value={targetPrice}
                        onChange={changeTargetPrice}
                        className="price arrowLess"
                        placeholder="0.00"
                        type="number"
                        name="targetPrice"
                      />
                    </div>
                    {/* <input
                      className="targetPrice"
                      value={targetPrice}
                      onChange={changeTargetPrice}
                      type="number"
                      id="targetPrice"
                      name="targetPrice"
                    /> */}
                    <button onClick={addLabourDifference}>Add</button>
                  </div>
                </div>
              </div>
            </div>

            <div className="setPricesList">
              {setPriceList.map(({ name, uid, price, display, quantity = 1 }) => {
                if (name === "Card Fee") {
                  // If card fee then need to show the vat inclusive price (if applicable)

                  if (vat) {
                    price = calcVatInclusive(price);
                  }
                }
                return (
                  <div className="displayLine" key={uid}>
                    <span>{name}</span>{" "}
                    <span>
                      {quantity} x £{Number(price).toFixed(2)} {/* {quantity} x £{display}  */}
                      <button onClick={() => removeSetPrice(uid)}>X</button>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* End of Set Prices */}

          <LabourCosts jobDescription={jobDescription} vat={showVat} />
        </div>
      </div>

      <div className="section">
        <h3 className="heading">Materials</h3>
        <div className="jobMaterialsList">
          {(jobDescription?.materials ?? []).map((mat) => {
            return (
              <div key={mat.materialCode} className="displayLine">
                <span>{mat.materialDescription}</span>
                <span>
                  {mat.quantity} x £{mat.priceWithAddOns ?? mat.itemRefPrice}
                </span>
              </div>
            );
          })}
        </div>

        <MaterialsCosts jobDescription={jobDescription} vat={showVat} />
      </div>
    </div>
  );
};

export default JobDescription;
